import React, { useEffect, useState, useRef } from "react";
import SignatureCanvas from "react-signature-canvas";
import './horizonTable.css';
import "../forms/themeCheckbox.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  adminEditLabelStyle,
  adminEditInputStyle,
  parseSiteRegisterDate,
  formatSiteRegisterDate,
  siteRegisterDatePickerProps,
  adminEditModalOverlayStyle,
  adminEditModalContentStyle,
  adminEditModalHeaderStyle,
  adminEditModalTitleStyle,
  adminEditModalBodyStyle,
  adminEditModalFooterStyle,
  adminEditCancelBtnStyle,
  adminEditSaveBtnStyle,
  adminEditSigBoxStyle,
} from "./adminEditModalTheme";
import { toast } from "react-toastify";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import onsiteproLogo from '../../assets/logo2 2.png';
import AdminTaylorImportModal, { adminIsPrimaryAdmin } from "./AdminTaylorImportModal";
import { ensureFormUuid } from "../../utils/formUuid";
import { buildSharePointFileName, toDdMmYyyy, addedByName } from "../../utils/formPdfHelpers";

import { canEditDeleteRecords } from "../../utils/rolePermissions";
function TtslDailyWorksheetPage() {
  const canEditDelete = canEditDeleteRecords();
  const handleDelete = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };
  const editClientSigCanvasRef = useRef(null);
  const editEngineerSigCanvasRef = useRef(null);
  const [forms, setForms] = useState([]);
  const [appUsers, setAppUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const pageSize = 10;
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const isAdminUser = adminIsPrimaryAdmin();
  const [deleteId, setDeleteId] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editForm, setEditForm] = useState(null);
  const [editClientSignature, setEditClientSignature] = useState("");
  const [editEngineerSignature, setEditEngineerSignature] = useState("");
  const generatingPdfRef = useRef(false);
  const [uploadingKey, setUploadingKey] = useState(null);
  
  // SharePoint upload modal state
  const [showSharePointUploadModal, setShowSharePointUploadModal] = useState(false);
  const [sharePointUploadRecord, setSharePointUploadRecord] = useState(null);
  const [sharePointPhaseType, setSharePointPhaseType] = useState('phase');
  const [sharePointPhaseNumber, setSharePointPhaseNumber] = useState('15');
  const [sharePointNetwork, setSharePointNetwork] = useState('');
  const [pendingDirectUpload, setPendingDirectUpload] = useState(false);
  useEffect(() => {
    if (pendingDirectUpload && sharePointUploadRecord) {
      setPendingDirectUpload(false);
      // eslint-disable-next-line no-use-before-define
      handleSharePointUpload();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingDirectUpload, sharePointUploadRecord]);

  // Helper function to convert date format from DD/MM/YYYY to YYYY-MM-DD for HTML date input
  const convertDateForInput = (dateString) => {
    if (!dateString) return '';
    // Check if it's already in YYYY-MM-DD format
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
      return dateString;
    }
    // Convert from DD/MM/YYYY to YYYY-MM-DD
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
      const [day, month, year] = dateString.split('/');
      return `${year}-${month}-${day}`;
    }
    return dateString;
  };

  // Helper function to convert date format from YYYY-MM-DD to DD/MM/YYYY for saving
  const convertDateForSave = (dateString) => {
    if (!dateString) return '';
    // Check if it's already in DD/MM/YYYY format
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
      return dateString;
    }
    // Convert from YYYY-MM-DD to DD/MM/YYYY
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
      const [year, month, day] = dateString.split('-');
      return `${day}/${month}/${year}`;
    }
    return dateString;
  };

  const handleEdit = (form) => {
    setEditForm({ ...form, formUuid: ensureFormUuid(form?.formUuid) });
    setEditClientSignature(form.clientSignature || "");
    setEditEngineerSignature(form.engineerSignature || "");
    setShowEditModal(true);
    
    // Load signatures after modal is fully rendered
    setTimeout(() => {
      // Load client signature
      const clientRef = editClientSigCanvasRef.current;
      if (clientRef) {
        clientRef.clear();
        if (form.clientSignature) {
          let sigSrc = form.clientSignature;
          
          // Ensure proper data URL format
          if (typeof sigSrc === 'string') {
            if (!sigSrc.startsWith('data:image')) {
              sigSrc = 'data:image/png;base64,' + sigSrc;
            }
          }
          
          const img = new window.Image();
          img.onload = () => {
            if (clientRef) {
              const canvas = clientRef.getCanvas();
              const ctx = canvas.getContext('2d');
              ctx.clearRect(0, 0, canvas.width, canvas.height);
              
              // Draw the image with proper scaling to maintain aspect ratio
              const scale = Math.min(canvas.width / img.width, canvas.height / img.height);
              const x = (canvas.width - img.width * scale) / 2;
              const y = (canvas.height - img.height * scale) / 2;
              
              ctx.drawImage(img, x, y, img.width * scale, img.height * scale);
            }
          };
          img.onerror = () => {
            console.error('Failed to load client signature image, Source:', sigSrc.substring(0, 100) + '...');
          };
          img.src = sigSrc;
        } else if (clientRef) {
          clientRef.clear();
        }
      }
      
      // Load engineer signature
      const engineerRef = editEngineerSigCanvasRef.current;
      if (engineerRef) {
        engineerRef.clear();
        if (form.engineerSignature) {
          let sigSrc = form.engineerSignature;
          
          // Ensure proper data URL format
          if (typeof sigSrc === 'string') {
            if (!sigSrc.startsWith('data:image')) {
              sigSrc = 'data:image/png;base64,' + sigSrc;
            }
          }
          
          const img = new window.Image();
          img.onload = () => {
            if (engineerRef) {
              const canvas = engineerRef.getCanvas();
              const ctx = canvas.getContext('2d');
              ctx.clearRect(0, 0, canvas.width, canvas.height);
              
              // Draw the image with proper scaling to maintain aspect ratio
              const scale = Math.min(canvas.width / img.width, canvas.height / img.height);
              const x = (canvas.width - img.width * scale) / 2;
              const y = (canvas.height - img.height * scale) / 2;
              
              ctx.drawImage(img, x, y, img.width * scale, img.height * scale);
            }
          };
          img.onerror = () => {
            console.error('Failed to load engineer signature image, Source:', sigSrc.substring(0, 100) + '...');
          };
          img.src = sigSrc;
        } else if (engineerRef) {
          engineerRef.clear();
        }
      }
    }, 500);
  };

  const clearEditClientSignature = () => {
    const ref = editClientSigCanvasRef.current;
    if (ref) {
      ref.clear();
    }
    setEditClientSignature("");
    setEditForm(prev => ({ ...prev, clientSignature: "" }));
  };
  const saveEditClientSignature = () => {
    const ref = editClientSigCanvasRef.current;
    if (ref && !ref.isEmpty()) {
      // Get the full canvas instead of trimmed to maintain proper size
      const canvas = ref.getCanvas();
      const sig = canvas.toDataURL("image/png");
      setEditClientSignature(sig);
      setEditForm(prev => ({ ...prev, clientSignature: sig }));
    }
  };
  const clearEditEngineerSignature = () => {
    const ref = editEngineerSigCanvasRef.current;
    if (ref) {
      ref.clear();
    }
    setEditEngineerSignature("");
    setEditForm(prev => ({ ...prev, engineerSignature: "" }));
  };
  const saveEditEngineerSignature = () => {
    const ref = editEngineerSigCanvasRef.current;
    if (ref && !ref.isEmpty()) {
      // Get the full canvas instead of trimmed to maintain proper size
      const canvas = ref.getCanvas();
      const sig = canvas.toDataURL("image/png");
      setEditEngineerSignature(sig);
      setEditForm(prev => ({ ...prev, engineerSignature: sig }));
    }
  };
  const handleEditChange = (field, value) => {
    setEditForm(prev => ({ ...prev, [field]: value }));
  };
  const handleEditSave = async () => {
    // Basic validation
    if (!editForm.site || !editForm.ttslJobNumber || !editForm.seJobNumber || !editForm.date || !editForm.engineer) {
      toast.error("All fields are required");
      return;
    }
    
    // Force save all signatures before saving the form
    const clientRef = editClientSigCanvasRef.current;
    if (clientRef && !clientRef.isEmpty()) {
      const canvas = clientRef.getCanvas();
      const sig = canvas.toDataURL("image/png");
      setEditClientSignature(sig);
      setEditForm(prev => ({ ...prev, clientSignature: sig }));
    }
    
    const engineerRef = editEngineerSigCanvasRef.current;
    if (engineerRef && !engineerRef.isEmpty()) {
      const canvas = engineerRef.getCanvas();
      const sig = canvas.toDataURL("image/png");
      setEditEngineerSignature(sig);
      setEditForm(prev => ({ ...prev, engineerSignature: sig }));
    }
    
    // Wait a bit for state updates, then save
    setTimeout(async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const baseUrl = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
        const token = localStorage.getItem("token");
        
        // Get the latest signatures from refs one more time to ensure we have them
        let finalClientSig = editForm.clientSignature;
        let finalEngineerSig = editForm.engineerSignature;
        
        if (clientRef && !clientRef.isEmpty()) {
          finalClientSig = clientRef.getCanvas().toDataURL("image/png");
        }
        if (engineerRef && !engineerRef.isEmpty()) {
          finalEngineerSig = engineerRef.getCanvas().toDataURL("image/png");
        }
        
        // Get user details for saving firstName and lastName
        const user = appUsers.find(u => u._id === editForm.userId);
        const addedByFirstName = user ? user.firstName : '';
        const addedByLastName = user ? user.lastName : '';
        
        const updatedForm = { 
          ...editForm, 
          formUuid: ensureFormUuid(editForm.formUuid),
          addedByFirstName,
          addedByLastName,
          clientSignature: finalClientSig, 
          engineerSignature: finalEngineerSig 
        };

        const res = await fetch(baseUrl + `/api/ttsl-daily-worksheet/${editForm._id}` , {
          method: "PUT",
          headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
          body: JSON.stringify(updatedForm)
        });
        const data = await res.json();
        if (res.ok && data.success) {
          setForms(forms.map(f => f._id === editForm._id ? { ...f, ...updatedForm } : f));
          setShowEditModal(false);
          toast.success("Updated successfully");
        } else {
          toast.error(data.message || "Failed to update");
        }
      } catch {
        toast.error("Failed to update");
      }
    }, 100);
  };

  // Truncate text function for table display
  const truncateText = (text, maxLength = 50) => {
    if (!text || typeof text !== 'string') return '';
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  // SharePoint Upload Handler
  const handleSharePointUpload = async () => {
    const siteNameForUpload = (sharePointUploadRecord?.site || '').trim();

    if (!siteNameForUpload) {
      toast.error('Site name is missing for this record.');
      return;
    }

    if (sharePointPhaseType === 'phase' && (!sharePointNetwork || sharePointNetwork.trim() === '')) {
      toast.error('Please select an area (EPN, LPN, or SPN)');
      return;
    }

    const payloadPhaseType = sharePointPhaseType === 'phase' ? 'phase' : 'non-phase';
    const payloadNetwork = sharePointPhaseType === 'phase' ? sharePointNetwork : '';
    const payloadPhaseNumber = sharePointPhaseType === 'phase' ? sharePointPhaseNumber : '';

    setShowSharePointUploadModal(false);

    await generatePDF(sharePointUploadRecord, {
      uploadOnly: true,
      phaseType: payloadPhaseType,
      phaseNumber: payloadPhaseNumber,
      network: payloadNetwork,
      siteName: siteNameForUpload,
      onSuccess: () => {
        setSharePointUploadRecord(null);
        setSharePointPhaseType('phase');
        setSharePointPhaseNumber('15');
        setSharePointNetwork('');
      },
      onError: () => {}
    });
  };

  const generatePDF = async (record, options = {}) => {
    // Prevent duplicate calls
    if (generatingPdfRef.current) {
      return;
    }
    generatingPdfRef.current = true;
    
    const shouldUploadToSharePoint = options.uploadOnly === true;
    const uploadConfig = shouldUploadToSharePoint ? {
      phaseType: options.phaseType || 'non-phase',
      phaseNumber: options.phaseNumber || '',
      network: options.network || '',
      siteName: options.siteName || '',
      onSuccess: options.onSuccess,
      onError: options.onError
    } : null;
    
    try {
      const doc = new jsPDF();
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      
      // Modern color scheme
      const primaryColor = [139, 22, 52]; // #8b1634
      const secondaryColor = [233, 207, 214]; // #e9cfd6
      const headerColor = [139, 22, 52]; // Dark magenta
      
      // Helper function to draw modern rounded rectangle
      const drawRoundedRect = (x, y, width, height, radius, fillColor, strokeColor, hasShadow = false) => {
        if (hasShadow) {
          doc.setFillColor(0, 0, 0, 0.1);
          doc.roundedRect(x + 1, y + 1, width, height, radius, radius, 'F');
        }
        doc.setFillColor(...fillColor);
        doc.setDrawColor(...strokeColor);
        doc.setLineWidth(0.5);
        doc.roundedRect(x, y, width, height, radius, radius, 'FD');
      };
      
      // ---- HEADER SECTION ----
      const headerHeight = 30;
      drawRoundedRect(0, 0, pageWidth, headerHeight, 0, primaryColor, primaryColor);
      
      // ---- ADD HIGH-RES LOGO ----
      const addLogoToPDF = () => {
        return new Promise((resolve) => {
          const logoImg = new Image();
          logoImg.crossOrigin = 'anonymous';
          logoImg.onload = function () {
            try {
              const logoWidth = 70;
              const aspectRatio = logoImg.height / logoImg.width;
              const logoHeight = logoWidth * aspectRatio;
              const logoX = 10;
              const logoY = (headerHeight - logoHeight) / 2;
              
              const canvas = document.createElement('canvas');
              const scale = 2.5;
              canvas.width = logoImg.width * scale;
              canvas.height = logoImg.height * scale;
              const ctx = canvas.getContext('2d');
              ctx.scale(scale, scale);
              ctx.drawImage(logoImg, 0, 0);
              
              const highResDataUrl = canvas.toDataURL('image/png', 1.0);
              doc.addImage(highResDataUrl, 'PNG', logoX, logoY, logoWidth, logoHeight, '', 'NONE');
            } catch (error) {
              doc.setFillColor(255, 255, 255);
              doc.rect(10, 6, 60, 15, 'F');
              doc.setFont("helvetica", "bold");
              doc.setFontSize(10);
              doc.setTextColor(0, 0, 0);
              doc.text("TAYLOR TECHNOLOGY", 15, 12);
              doc.text("SYSTEMS LIMITED", 15, 17);
            }
            resolve();
          };
          logoImg.onerror = function () {
            doc.setFillColor(255, 255, 255);
            doc.rect(10, 6, 60, 15, 'F');
            doc.setFont("helvetica", "bold");
            doc.setFontSize(10);
            doc.setTextColor(0, 0, 0);
            doc.text("TAYLOR TECHNOLOGY", 15, 12);
            doc.text("SYSTEMS LIMITED", 15, 17);
            resolve();
          };
          logoImg.src = onsiteproLogo;
        });
      };
      
      await addLogoToPDF();
      
      // ---- HEADER TEXT ----
      const titleX = 90;
      doc.setFont("helvetica", "bold");
      doc.setFontSize(16);
      doc.setTextColor(255, 255, 255);
      doc.text("TTSL Daily Worksheet Report", titleX, 13);
      
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.text("TAYLOR TECHNOLOGY SYSTEMS LIMITED", titleX, 19);
      
      let yPosition = headerHeight + 10;
      
      // ---- Section 1: Basic Information ----
      doc.setFillColor(139, 22, 52);
      doc.setTextColor(255, 255, 255);
      doc.setFont("helvetica", "bold");
      
      doc.rect(10, yPosition, pageWidth - 20, 8, "F");
      doc.text("1", 14, yPosition + 5.5);
      doc.text("Basic Information", 22, yPosition + 5.5);
      yPosition += 8;
      
      autoTable(doc, {
        startY: yPosition,
        columnStyles: {
          0: { cellWidth: 50 },
          1: { cellWidth: 65 },
          2: { cellWidth: 30 },
          3: { cellWidth: 45 },
        },
        head: [
          [
            { content: "Site:", styles: { fillColor: [230, 230, 230], fontStyle: "bold" } },
            { content: record.site || "", styles: { halign: "center" } },
            { content: "Date:", styles: { fillColor: [230, 230, 230], fontStyle: "bold", halign: "center" } },
            { content: record.date || "", styles: { halign: "center" } },
          ],
          [
            { content: "TTSL Job Number:", styles: { fillColor: [230, 230, 230], fontStyle: "bold" } },
            { content: record.ttslJobNumber || "", styles: { halign: "center" } },
            { content: "SE Job Number:", styles: { fillColor: [230, 230, 230], fontStyle: "bold", halign: "center" } },
            { content: record.seJobNumber || "", styles: { halign: "center" } },
          ],
          [
            { content: "Engineer:", styles: { fillColor: [230, 230, 230], fontStyle: "bold" } },
            { content: record.engineer || "", styles: { halign: "center" } },
            { content: "Time On Site:", styles: { fillColor: [230, 230, 230], fontStyle: "bold", halign: "center" } },
            { content: record.timeOnSite || "", styles: { halign: "center" } },
          ],
          [
            { content: "Time Off Site:", styles: { fillColor: [230, 230, 230], fontStyle: "bold" } },
            { content: record.timeOffSite || "", styles: { halign: "center" } },
            { content: "Completed:", styles: { fillColor: [230, 230, 230], fontStyle: "bold", halign: "center" } },
            { content: String(record.completed !== undefined ? record.completed : false), styles: { halign: "center" } },
          ],
        ],
        body: [
          [
            { content: "Description Of Works:", styles: { fillColor: [230, 230, 230], fontStyle: "bold" } },
            { content: record.descriptionOfWorks || "", styles: { halign: "center" } },
            { content: "Further Work:", styles: { fillColor: [230, 230, 230], fontStyle: "bold", halign: "center" } },
            { content: String(record.furtherWork !== undefined ? record.furtherWork : false), styles: { halign: "center" } },
          ],
          [
            { content: "Comments:", styles: { fillColor: [230, 230, 230], fontStyle: "bold" } },
            { content: record.comments || "", styles: { halign: "center" } },
            { content: "", styles: { halign: "center" } },
            { content: "", styles: { halign: "center" } },
          ],
        ],
        styles: {
          font: "helvetica",
          fontSize: 9,
          cellPadding: 3,
          overflow: "linebreak",
          valign: "middle",
        },
        theme: "grid",
        tableWidth: pageWidth - 20,
        margin: { left: 10 },
        headStyles: {
          fillColor: [245, 245, 245],
          textColor: [0, 0, 0],
          lineWidth: 0.2,
        },
        bodyStyles: {
          lineWidth: 0.2,
          textColor: [0, 0, 0],
        },
      });
      
      yPosition = doc.lastAutoTable.finalY + 2;
      
      // ---- Section 2: Signatories ----
      if (yPosition + 60 > pageHeight - 30) {
        doc.addPage();
        yPosition = 20;
      }
      
      doc.setFillColor(139, 22, 52);
      doc.setTextColor(255, 255, 255);
      doc.setFont("helvetica", "bold");
      doc.rect(10, yPosition, pageWidth - 20, 10, "F");
      doc.text("Section 2 : Signatories", 15, yPosition + 7);
      yPosition += 18;
      
      // Two signature boxes side by side
      const boxWidth = (pageWidth - 30) / 2;
      const boxHeight = 40;
      
      // Helper function to add signature with high quality - improved implementation
      const addSignatureToPDF = async (signatureData, x, y, maxWidth, maxHeight) => {
        if (!signatureData) return;
        
        try {
          // Ensure proper data URL format
          let sigSrc = signatureData;
          if (!sigSrc.startsWith('data:image')) {
            sigSrc = 'data:image/png;base64,' + sigSrc;
          }
          
          return new Promise((resolve) => {
            const sigImg = new Image();
            sigImg.crossOrigin = 'anonymous';
            
            sigImg.onload = () => {
              try {
                // Calculate dimensions maintaining aspect ratio while fitting within constraints
                const aspectRatio = sigImg.width / sigImg.height;
                
                // Calculate dimensions based on width constraint
                let imgWidth = maxWidth;
                let imgHeight = maxWidth / aspectRatio;
                
                // If height exceeds maxHeight, recalculate based on height constraint
                if (imgHeight > maxHeight) {
                  imgHeight = maxHeight;
                  imgWidth = maxHeight * aspectRatio;
                }
                
                // Ensure both dimensions don't exceed their maximums (safety check)
                imgWidth = Math.min(imgWidth, maxWidth);
                imgHeight = Math.min(imgHeight, maxHeight);
                
                // Use higher scale factor for better quality (4x for very crisp rendering)
                const scale = 4;
                
                // Create high-resolution canvas
                const canvas = document.createElement('canvas');
                canvas.width = Math.round(imgWidth * scale);
                canvas.height = Math.round(imgHeight * scale);
                
                const ctx = canvas.getContext('2d');
                
                // Set high-quality rendering options for crisp signatures
                ctx.imageSmoothingEnabled = true;
                ctx.imageSmoothingQuality = 'high';
                
                // Clear canvas with white background
                ctx.fillStyle = '#FFFFFF';
                ctx.fillRect(0, 0, canvas.width, canvas.height);
                
                // Scale the image up using high-quality rendering
                // This approach scales up the original image to the larger canvas size
                ctx.drawImage(
                  sigImg, 
                  0, 0, sigImg.width, sigImg.height,  // Source rectangle (original size)
                  0, 0, canvas.width, canvas.height   // Destination rectangle (scaled up)
                );
                
                // Convert to high-res data URL with maximum quality (1.0 = no compression loss)
                const highResDataUrl = canvas.toDataURL('image/png', 1.0);
                
                // Add to PDF with no compression ('NONE') to preserve quality
                doc.addImage(highResDataUrl, 'PNG', x, y, imgWidth, imgHeight, '', 'NONE');
              } catch (err) {
                console.error('Error adding signature to PDF:', err);
                // Fallback: try direct addition without canvas processing
                try {
                  doc.addImage(sigSrc, 'PNG', x, y, maxWidth, maxHeight);
                } catch (fallbackErr) {
                  console.error('Fallback signature addition also failed:', fallbackErr);
                }
              }
              resolve();
            };
            
            sigImg.onerror = () => {
              console.error('Error loading signature image');
              resolve();
            };
            
            sigImg.src = sigSrc;
          });
        } catch (err) {
          console.error('Signature processing error:', err);
        }
      };
      
      // Client Signature box
      doc.setDrawColor(200, 200, 200);
      doc.setFillColor(248, 248, 248);
      doc.roundedRect(10, yPosition, boxWidth, boxHeight, 3, 3, "FD");
      
      doc.setTextColor(139, 22, 52);
      doc.setFontSize(10);
      doc.text("Client Signature", 15, yPosition + 8);
      
      // Define exact same size constraints for both signatures
      const signatureMaxWidth = 50;
      const signatureMaxHeight = 22;
      const signatureX = 15;
      const signatureY = yPosition + 12;
      
      // Add client signature using helper function with exact constraints
      await addSignatureToPDF(record.clientSignature, signatureX, signatureY, signatureMaxWidth, signatureMaxHeight);
      
      // Engineer Signature box
      const engineerBoxX = 10 + boxWidth + 10;
      doc.setDrawColor(200, 200, 200);
      doc.setFillColor(248, 248, 248);
      doc.roundedRect(engineerBoxX, yPosition, boxWidth, boxHeight, 3, 3, "FD");
      
      doc.setTextColor(139, 22, 52);
      doc.setFontSize(10);
      doc.text("Engineer Signature", engineerBoxX + 5, yPosition + 8);
      
      // Add engineer signature using EXACT same constraints as client
      const engineerSignatureX = engineerBoxX + 5;
      await addSignatureToPDF(record.engineerSignature, engineerSignatureX, signatureY, signatureMaxWidth, signatureMaxHeight);
      
      yPosition += boxHeight + 10;
      
      // ---- Footer Section ----
      const footerY = pageHeight - 25;
      drawRoundedRect(0, footerY, pageWidth, 25, 0, [248, 249, 250], [200, 200, 200]);
      
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.setTextColor(150, 150, 150);
      doc.text(
        `Generated on: ${new Date().toLocaleDateString()} at ${new Date().toLocaleTimeString()}`,
        20,
        footerY + 8
      );
      doc.text("Page 1 of 1", pageWidth - 30, footerY + 15);
      
      // Decorative border removed
      
      // Build filename and either save or upload
      const safeName = String(record.site || 'TTSLDailyWorksheet').replace(/[\\/:"*?<>|]+/g, '-');
      const safeDate = String(record.date || 'Report').replace(/[\\/:"*?<>|]+/g, '-');
      
      let fileName;
      if (shouldUploadToSharePoint && uploadConfig) {
        fileName = buildSharePointFileName([
          addedByName(record),
          uploadConfig.siteName,
          toDdMmYyyy(record.date),
        ]);
      } else {
        // For regular download, use full format with prefix and date
        fileName = `TTSLDailyWorksheet_${safeName}_${safeDate}.pdf`;
      }
      
      if (shouldUploadToSharePoint && uploadConfig) {
        try {
          const key = `${record._id || ''}|${record.site || ''}|${record.date || ''}`;
          setUploadingKey(key);
          const apiUrl = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
          const dataUri = doc.output('datauristring');
          
          // Prepare SharePoint upload parameters
          const uploadParams = {
            fileName,
            fileBase64: dataUri,
            phaseType: uploadConfig.phaseType,
            phaseNumber: uploadConfig.phaseNumber,
            network: uploadConfig.network,
            siteName: uploadConfig.siteName,
            uploadContext: "general-forms-tablets", uploadSubFolder: "TTS Daily Worksheet" // fixed folder: Assurance/13 FORMS/GENERAL
          };
          
          const res = await fetch(`${apiUrl}/api/sharepoint/upload`, {
            method: 'POST',
            headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("token")}` },
            body: JSON.stringify(uploadParams)
          });
          if (res.status !== 204 && !res.ok) {
            let msg = 'SharePoint upload failed';
            try {
              const out = await res.json();
              msg = out?.message || msg;
            } catch (_) {}
            throw new Error(msg);
          }
          toast.success("PDF uploaded to SharePoint successfully!");
          if (uploadConfig.onSuccess) {
            uploadConfig.onSuccess();
          }
        } catch (err) {
          toast.error(err?.message || "SharePoint upload failed");
          if (uploadConfig.onError) {
            uploadConfig.onError(err);
          }
        } finally {
          setUploadingKey(null);
        }
      } else {
        doc.save(fileName);
        toast.success("Professional TTSL Daily Worksheet PDF generated successfully!");
      }
    } catch (err) {
      console.error('Error generating PDF:', err);
      toast.error('Failed to generate PDF');
    } finally {
      generatingPdfRef.current = false;
    }
  };

  useEffect(() => {
    async function fetchForms() {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const baseUrl = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
        const token = localStorage.getItem("token");
        const res = await fetch(baseUrl + `/api/ttsl-daily-worksheet`, {
          headers: { "Authorization": `Bearer ${token}` }
        });
        const data = await res.json();
        if (res.ok && data.success) {
          setForms(data.data);
        } else {
          toast.error(data.message || "Failed to fetch forms");
        }
      } catch {
        toast.error("Failed to fetch forms");
      }
    }
    async function fetchAppUsers() {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const baseUrl = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
        const token = localStorage.getItem("token");
        const res = await fetch(baseUrl + "/api/app-users", {
          headers: { "Authorization": `Bearer ${token}` }
        });
        const data = await res.json();
        if (res.ok && data.success && Array.isArray(data.data)) {
          setAppUsers(data.data);
        } else {
          setAppUsers([]);
        }
      } catch {
        setAppUsers([]);
      }
    }
    fetchForms();
    fetchAppUsers();
  }, []);

  const formatDateForDisplay = (d) => {
    if (!d) return "—";
    const x = new Date(d);
    return isNaN(x.getTime()) ? d : x.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
  };

  // ...existing code for search, pagination, delete, modal, and rendering (similar to LserFormPage.js)...

  return (
    <div style={{
      background: '#ffffff',
      borderRadius: '20px',
      boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
      padding: '24px',
      marginBottom: '24px'
    }}>
      {/* Header Section */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '24px',
        flexWrap: 'wrap',
        gap: '16px'
      }}>
        <h2 style={{
          fontSize: '24px',
          fontWeight: '700',
          color: '#1a202c',
          margin: 0
        }}>TTSL Daily Worksheet</h2>
        
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          flexWrap: 'wrap'
        }}>
          {isAdminUser && (
            <button
              type="button"
              onClick={() => setShowImportModal(true)}
              style={{
                background: "#8b1634",
                color: "#fff",
                border: "none",
                borderRadius: "10px",
                padding: "10px 14px",
                fontWeight: "600",
                fontSize: "13px",
                cursor: "pointer",
              }}
            >
              Import File
            </button>
          )}
          <div style={{
            position: 'relative',
            display: 'flex',
            alignItems: 'center'
          }}>
            <i className="fa fa-search" style={{
              position: 'absolute',
              left: '12px',
              color: '#8b1634',
              fontSize: '14px'
            }}></i>
            <input 
              type="text" 
              placeholder="Type to Search" 
              value={search} 
              onChange={e=>{ setSearch(e.target.value); setPage(1); }}
              style={{
                padding: '10px 12px 10px 36px',
                borderRadius: '12px',
                border: '1px solid #e2e8f0',
                fontSize: '14px',
                outline: 'none',
                width: '250px',
                transition: 'border-color 0.2s'
              }}
              onFocus={(e) => e.target.style.borderColor = '#8b1634'}
              onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
            />
          </div>
        </div>
      </div>

      {/* Table Container */}
      <div style={{
        overflowX: 'auto',
        borderRadius: '12px',
        border: '1px solid #e2e8f0'
      }}>
        {/* Table Header */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 1fr 0.9fr 1fr 1fr 1fr 1.2fr',
          background: '#f7fafc',
          padding: '12px 16px',
          borderBottom: '1px solid #e2e8f0',
          gap: '12px',
          alignItems: 'center'
        }}>
          <div style={{fontWeight: '600', color: '#8b1634', fontSize: '14px'}}>Site</div>
          <div style={{fontWeight: '600', color: '#8b1634', fontSize: '14px'}}>TTSL Job No.</div>
          <div style={{fontWeight: '600', color: '#8b1634', fontSize: '14px'}}>SE Job No.</div>
          <div style={{fontWeight: '600', color: '#8b1634', fontSize: '14px'}}>Date</div>
          <div style={{fontWeight: '600', color: '#8b1634', fontSize: '14px'}}>Engineer</div>
          <div style={{fontWeight: '600', color: '#8b1634', fontSize: '14px'}}>Added By</div>
          <div style={{fontWeight: '600', color: '#8b1634', fontSize: '14px'}}>Updated Date</div>
          <div style={{fontWeight: '600', color: '#8b1634', fontSize: '14px'}}>Actions</div>
        </div>

        {/* Table Body */}
        <div>
          {(() => {
            // Filter forms based on search term
            const filteredForms = forms.filter((f) => {
              if (!search.trim()) return true;
              
              const searchLower = search.toLowerCase();
              // First check if firstName and lastName are saved in the record
              // If not, try to find user from appUsers array
              let userName = '-';
              if (f.addedByFirstName && f.addedByLastName) {
                userName = `${f.addedByFirstName} ${f.addedByLastName}`;
              } else {
              const user = appUsers.find(u => u._id === f.userId);
                userName = user ? `${user.firstName} ${user.lastName}` : (f.userId || '-');
              }
              
              return (
                (f.site || '').toLowerCase().includes(searchLower) ||
                (f.ttslJobNumber || '').toLowerCase().includes(searchLower) ||
                (f.seJobNumber || '').toLowerCase().includes(searchLower) ||
                (f.date || '').toLowerCase().includes(searchLower) ||
                (f.engineer || '').toLowerCase().includes(searchLower) ||
                userName.toLowerCase().includes(searchLower)
              );
            });
            
            // Sort filtered forms
            const sortedForms = [...filteredForms].sort((a, b) => {
              // Sort by createdAt if available, otherwise by _id (MongoDB ObjectIds are sortable by creation time)
              if (a.createdAt && b.createdAt) {
                return new Date(b.createdAt) - new Date(a.createdAt);
              }
              // Compare _id strings directly (newer ObjectIds have higher values)
              return (b._id || '').toString().localeCompare((a._id || '').toString());
            });
            
            // Pagination
            const startIndex = (page - 1) * pageSize;
            const endIndex = startIndex + pageSize;
            const paginatedForms = sortedForms.slice(startIndex, endIndex);
            
            if (sortedForms.length === 0) {
              return (
                <div style={{
                  textAlign: 'center',
                  padding: '40px',
                  color: '#718096',
                  fontSize: '16px'
                }}>No records found.</div>
              );
            }
            
            return paginatedForms.map((f, idx) => {
              // First check if firstName and lastName are saved in the record
              // If not, try to find user from appUsers array
              let userName = '-';
              if (f.addedByFirstName && f.addedByLastName) {
                userName = `${f.addedByFirstName} ${f.addedByLastName}`;
              } else {
              const user = appUsers.find(u => u._id === f.userId);
                userName = user ? `${user.firstName} ${user.lastName}` : (f.userId || '-');
              }
              return (
                <div 
                  key={f._id || idx}
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr 1fr 0.9fr 1fr 1fr 1fr 1.2fr',
                    padding: '16px',
                    borderBottom: '1px solid #f1f5f9',
                    gap: '12px',
                    alignItems: 'center',
                    transition: 'background-color 0.2s'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f9fafb'}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                >
                  <div style={{color: '#2d3748', fontSize: '14px'}}>{f.site || '—'}</div>
                  <div style={{color: '#2d3748', fontSize: '14px'}}>{f.ttslJobNumber || '—'}</div>
                  <div style={{color: '#2d3748', fontSize: '14px'}}>{f.seJobNumber || '—'}</div>
                  <div style={{color: '#2d3748', fontSize: '14px'}}>{f.date || '—'}</div>
                  <div style={{color: '#2d3748', fontSize: '14px'}}>{f.engineer || '—'}</div>
                  <div style={{color: '#2d3748', fontSize: '14px'}}>{userName || '—'}</div>
                  <div style={{color: '#2d3748', fontSize: '14px'}}>{formatDateForDisplay(f.updatedAt || f.createdAt || f.date)}</div>
                  <div style={{display: 'flex', gap: '8px', alignItems: 'center'}}>
                    {canEditDelete && (
                      <button 
                        onClick={()=>handleEdit(f)}
                        title="Edit"
                        style={{
                          background: 'transparent',
                          border: 'none',
                          cursor: 'pointer',
                          padding: '6px',
                          borderRadius: '6px',
                          transition: 'background-color 0.2s',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0fdf4'}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                      >
                        <i className="fa fa-edit" style={{color:'#22c55e', fontSize: '16px'}}></i>
                      </button>
                    )}
                    <button 
                      onClick={()=>generatePDF(f)}
                      title="Generate PDF"
                      style={{
                        background: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        padding: '6px',
                        borderRadius: '6px',
                        transition: 'background-color 0.2s',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#fef2f2'}
                      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                    >
                      <i className="fa fa-file-pdf-o" style={{color:'#dc2626', fontSize: '16px'}}></i>
                    </button>
                    {(() => { 
                      const k = `${f._id || ''}|${f.site || ''}|${f.date || ''}`; 
                      const busy = uploadingKey === k; 
                      return (
                        <button 
                          onClick={()=>{
                            if (!busy) {
                              setSharePointUploadRecord(f);
                              setSharePointPhaseType('phase');
                              setSharePointPhaseNumber('15');
                              setSharePointNetwork('');
                              setSharePointPhaseType("non-phase"); setPendingDirectUpload(true);
                            }
                          }}
                          disabled={busy}
                          title={busy ? "Uploading..." : "Upload to SharePoint"}
                          style={{
                            background: 'transparent',
                            border: 'none',
                            cursor: busy ? 'not-allowed' : 'pointer',
                            padding: '6px',
                            borderRadius: '6px',
                            transition: 'background-color 0.2s',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            opacity: busy ? 0.6 : 1
                          }}
                          onMouseEnter={(e) => !busy && (e.currentTarget.style.backgroundColor = '#f0fdf4')}
                          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                        >
                          <i className={busy ? "fa fa-spinner fa-spin" : "fa fa-upload"} style={{color:'#22c55e', fontSize: '16px'}}></i>
                        </button>
                      ); 
                    })()}
                    {canEditDelete && (
                      <button 
                        onClick={()=>handleDelete(f._id)}
                        title="Delete"
                        style={{
                          background: 'transparent',
                          border: 'none',
                          cursor: 'pointer',
                          padding: '6px',
                          borderRadius: '6px',
                          transition: 'background-color 0.2s',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#fef2f2'}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                      >
                        <i className="fa fa-trash" style={{color:'#e53e3e', fontSize: '16px'}}></i>
                      </button>
                    )}
                  </div>
                </div>
              );
            });
          })()}
        </div>
      </div>

      {/* Pagination */}
      {(() => {
        // Calculate filtered forms for pagination
        const filteredForms = forms.filter((f) => {
          if (!search.trim()) return true;
          
          const searchLower = search.toLowerCase();
          const user = appUsers.find(u => u._id === f.userId);
          const userName = user ? `${user.firstName} ${user.lastName}` : (f.userId || '-');
          
          return (
            (f.site || '').toLowerCase().includes(searchLower) ||
            (f.ttslJobNumber || '').toLowerCase().includes(searchLower) ||
            (f.seJobNumber || '').toLowerCase().includes(searchLower) ||
            (f.date || '').toLowerCase().includes(searchLower) ||
            (f.engineer || '').toLowerCase().includes(searchLower) ||
            userName.toLowerCase().includes(searchLower)
          );
        });
        
        const totalPages = Math.ceil(filteredForms.length / pageSize);
        
        return (
          <div style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            marginTop: '18px',
            gap: '12px'
          }}>
            <button 
              disabled={page===1} 
              onClick={()=>setPage(page-1)}
              style={{
                padding: '8px 16px',
                borderRadius: '8px',
                border: '1px solid #e2e8f0',
                background: page===1 ? '#f7fafc' : '#ffffff',
                color: page===1 ? '#a0aec0' : '#8b1634',
                cursor: page===1 ? 'not-allowed' : 'pointer',
                fontSize: '14px',
                fontWeight: '500'
              }}
            >Prev</button>
            <span style={{
              fontWeight: '700',
              color: '#8b1634',
              fontSize: '16px'
            }}>{page} / {totalPages || 1}</span>
            <button 
              disabled={page===totalPages || totalPages === 0} 
              onClick={()=>setPage(page+1)}
              style={{
                padding: '8px 16px',
                borderRadius: '8px',
                border: '1px solid #e2e8f0',
                background: page===totalPages || totalPages === 0 ? '#f7fafc' : '#ffffff',
                color: page===totalPages || totalPages === 0 ? '#a0aec0' : '#8b1634',
                cursor: page===totalPages || totalPages === 0 ? 'not-allowed' : 'pointer',
                fontSize: '14px',
                fontWeight: '500'
              }}
            >Next</button>
          </div>
        );
      })()}
      {/* Edit Modal */}
      {showEditModal && editForm && (
        <div className="modal fade show" style={adminEditModalOverlayStyle} tabIndex="-1">
          <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content" style={adminEditModalContentStyle}>
              <div className="modal-header" style={adminEditModalHeaderStyle}>
                <h5 className="modal-title" style={adminEditModalTitleStyle}>Edit TTSL Daily Worksheet</h5>
                <button type="button" className="btn-close btn-close-white" onClick={()=>setShowEditModal(false)} />
              </div>
              <div className="modal-body" style={adminEditModalBodyStyle}>
                <div className="row g-3">
                  <div className="col-12 col-md-4">
                    <label style={adminEditLabelStyle}>Site</label>
                    <input type="text" className="form-control" style={adminEditInputStyle} value={editForm.site} onChange={e=>handleEditChange('site', e.target.value)} />
                  </div>
                  <div className="col-12 col-md-4">
                    <label style={adminEditLabelStyle}>TTSL Job Number</label>
                    <input
                      type="text"
                      className="form-control"
                      style={adminEditInputStyle}
                      value={editForm.ttslJobNumber}
                      onChange={e=>handleEditChange('ttslJobNumber', e.target.value.replace(/[^0-9]/g, ''))}
                      pattern="[0-9]*"
                      inputMode="numeric"
                    />
                  </div>
                  <div className="col-12 col-md-4">
                    <label style={adminEditLabelStyle}>SE Job Number</label>
                    <input
                      type="text"
                      className="form-control"
                      style={adminEditInputStyle}
                      value={editForm.seJobNumber}
                      onChange={e=>handleEditChange('seJobNumber', e.target.value.replace(/[^0-9]/g, ''))}
                      pattern="[0-9]*"
                      inputMode="numeric"
                    />
                  </div>
                </div>
                <div className="row g-3 mt-1">
                  <div className="col-12 col-md-4">
                    <label style={adminEditLabelStyle}>Date</label>
                    <div className="site-register-datepicker-wrap">
                      <DatePicker
                        {...siteRegisterDatePickerProps}
                        selected={parseSiteRegisterDate(editForm.date)}
                        onChange={(d) => handleEditChange('date', formatSiteRegisterDate(d))}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-4">
                    <label style={adminEditLabelStyle}>Engineer</label>
                    <input type="text" className="form-control" style={adminEditInputStyle} value={editForm.engineer} onChange={e=>handleEditChange('engineer', e.target.value)} />
                  </div>
                  <div className="col-12 col-md-4">
                    <label style={adminEditLabelStyle}>Time On Site</label>
                    <input type="time" className="form-control" style={adminEditInputStyle} value={editForm.timeOnSite || ''} onChange={e=>handleEditChange('timeOnSite', e.target.value)} />
                  </div>
                </div>
                <div className="row g-3 mt-1">
                  <div className="col-12 col-md-4">
                    <label style={adminEditLabelStyle}>Time Off Site</label>
                    <input type="time" className="form-control" style={adminEditInputStyle} value={editForm.timeOffSite || ''} onChange={e=>handleEditChange('timeOffSite', e.target.value)} />
                  </div>
                  <div className="col-12 col-md-4">
                    <label style={adminEditLabelStyle}>Description Of Works</label>
                    <input type="text" className="form-control" style={adminEditInputStyle} value={editForm.descriptionOfWorks} onChange={e=>handleEditChange('descriptionOfWorks', e.target.value)} />
                  </div>
                  <div className="col-12 col-md-4">
                    <label style={adminEditLabelStyle}>Completed</label>
                    <input type="text" className="form-control" style={adminEditInputStyle} value={editForm.completed} onChange={e=>handleEditChange('completed', e.target.value)} />
                  </div>
                </div>
                <div className="row g-3 mt-1">
                  <div className="col-12 col-md-4">
                    <label style={adminEditLabelStyle}>Further Work</label>
                    <input type="text" className="form-control" style={adminEditInputStyle} value={editForm.furtherWork} onChange={e=>handleEditChange('furtherWork', e.target.value)} />
                  </div>
                  <div className="col-12 col-md-8">
                    <label style={adminEditLabelStyle}>Comments</label>
                    <input type="text" className="form-control" style={adminEditInputStyle} value={editForm.comments} onChange={e=>handleEditChange('comments', e.target.value)} />
                  </div>
                </div>
                <div className="row g-3 mt-1">
                  <div className="col-12 col-md-6">
                    <label style={adminEditLabelStyle}>Client Signature</label>
                    <div style={adminEditSigBoxStyle()}>
                      {editForm?.clientSignature ? (
                        <img
                          src={editForm.clientSignature.startsWith('data:image')
                            ? editForm.clientSignature
                            : `data:image/png;base64,${editForm.clientSignature}`}
                          alt="Client Signature"
                          style={{
                            maxWidth: '100%',
                            maxHeight: '100px',
                            objectFit: 'contain',
                            border: '1px solid #ddd',
                            borderRadius: '8px',
                            padding: '4px',
                            backgroundColor: 'white',
                          }}
                          onError={(e) => {
                            e.target.style.display = 'none';
                          }}
                        />
                      ) : (
                        <div style={{ color: '#888', fontSize: '14px', padding: '20px' }}>
                          Signature (Disabled in Edit)
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <label style={adminEditLabelStyle}>Engineer Signature</label>
                    <div style={adminEditSigBoxStyle()}>
                      {editForm?.engineerSignature ? (
                        <img
                          src={editForm.engineerSignature.startsWith('data:image')
                            ? editForm.engineerSignature
                            : `data:image/png;base64,${editForm.engineerSignature}`}
                          alt="Engineer Signature"
                          style={{
                            maxWidth: '100%',
                            maxHeight: '100px',
                            objectFit: 'contain',
                            border: '1px solid #ddd',
                            borderRadius: '8px',
                            padding: '4px',
                            backgroundColor: 'white',
                          }}
                          onError={(e) => {
                            e.target.style.display = 'none';
                          }}
                        />
                      ) : (
                        <div style={{ color: '#888', fontSize: '14px', padding: '20px' }}>
                          Signature (Disabled in Edit)
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer" style={adminEditModalFooterStyle}>
                <button type="button" className="btn" style={adminEditCancelBtnStyle} onClick={()=>setShowEditModal(false)}>Cancel</button>
                <button type="button" className="btn" style={adminEditSaveBtnStyle} onClick={handleEditSave}>Save</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* SharePoint Upload Modal */}
      {showSharePointUploadModal && sharePointUploadRecord && (
        <div className="modal fade show" style={{display:'block', background:'rgba(0,0,0,0.3)'}} tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content" style={{maxWidth:'600px', margin:'0 auto'}}>
              <div className="modal-header">
                <h5 className="modal-title">Upload to SharePoint</h5>
                <button type="button" className="btn-close" onClick={()=>{
                  setShowSharePointUploadModal(false);
                  setSharePointUploadRecord(null);
                  setSharePointPhaseType('phase');
                  setSharePointPhaseNumber('15');
                  setSharePointNetwork('');
                }}></button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="mb-3 col-12">
                    <label className="form-label fw-semibold">Type <span style={{color:'red'}}>*</span></label>
                    <select 
                      className="form-select" 
                      value={sharePointPhaseType}
                      onChange={(e) => {
                        setSharePointPhaseType(e.target.value);
                        if (e.target.value === 'non-phase') {
                          setSharePointNetwork('');
                        }
                      }}
                    >
                      <option value="phase">Phase</option>
                      <option value="non-phase">Non Phase</option>
                    </select>
                  </div>
                  
                  {sharePointPhaseType === 'phase' && (
                    <>
                      <div className="mb-3 col-md-6">
                        <label className="form-label fw-semibold">Phase Number <span style={{color:'red'}}>*</span></label>
                        <select 
                          className="form-select" 
                          value={sharePointPhaseNumber}
                          onChange={(e) => {
                            setSharePointPhaseNumber(e.target.value);
                          }}
                        >
                          <option value="15">Phase 15 (2025)</option>
                          <option value="16">Phase 16 (2026)</option>
                        </select>
                      </div>
                      <div className="mb-3 col-md-6">
                        <label className="form-label fw-semibold">Area <span style={{color:'red'}}>*</span></label>
                        <select 
                          className="form-select" 
                          value={sharePointNetwork}
                          onChange={(e) => {
                            setSharePointNetwork(e.target.value);
                          }}
                        >
                          <option value="">Select Area</option>
                          <option value="EPN">EPN</option>
                          <option value="LPN">LPN</option>
                          <option value="SPN">SPN</option>
                        </select>
                      </div>
                    </>
                  )}
                  
                </div>
              </div>
              <div className="modal-footer">
                <button 
                  type="button" 
                  className="btn btn-secondary" 
                  onClick={()=>{
                    setShowSharePointUploadModal(false);
                    setSharePointUploadRecord(null);
                    setSharePointPhaseType('phase');
                    setSharePointPhaseNumber('15');
                    setSharePointNetwork('');
                  }}
                >
                  Cancel
                </button>
                <button 
                  type="button" 
                  className="btn" 
                  style={{background:'#8b1634', color:'#fff', fontWeight:600}}
                  onClick={handleSharePointUpload}
                >
                  Upload to SharePoint
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <AdminTaylorImportModal
        open={showImportModal}
        onClose={() => setShowImportModal(false)}
        title="Upload TTSL Daily Worksheet File"
        importPath="ttsl-daily-worksheet/import-form"
        isAdminUser={isAdminUser}
        onImported={({ insertedRow }) => {
          if (insertedRow && insertedRow._id) {
            setForms((prev) => [insertedRow, ...prev]);
            setPage(1);
          }
        }}
      />

      {/* Delete Modal */}
      {showDeleteModal && (
        <div className="modal fade show" style={{display:'block', background:'rgba(0,0,0,0.3)'}} tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Delete TTSL Daily Worksheet</h5>
                <button type="button" className="btn-close" onClick={()=>setShowDeleteModal(false)}></button>
              </div>
              <div className="modal-body">
                Are you sure you want to delete this record?
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={()=>setShowDeleteModal(false)}>Cancel</button>
                <button type="button" className="btn btn-danger" onClick={async()=>{
                  if (!deleteId) return;
                  try {
                    const apiUrl = process.env.REACT_APP_API_URL;
                    const baseUrl = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
                    const token = localStorage.getItem("token");
                    const res = await fetch(baseUrl + `/api/ttsl-daily-worksheet/${deleteId}`, {
                      method: "DELETE",
                      headers: { "Authorization": `Bearer ${token}` }
                    });
                    const data = await res.json();
                    if (res.ok && data.success) {
                      setForms(forms.filter(f => f._id !== deleteId));
                      toast.success("Deleted successfully!");
                    } else {
                      toast.error(data.message || "Failed to delete");
                    }
                  } catch {
                    toast.error("Failed to delete");
                  }
                  setShowDeleteModal(false);
                  setDeleteId(null);
                }}>Delete</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default TtslDailyWorksheetPage;
